export const fabVariants = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  warning: 'warning',
  outline: 'outline',
};
export const defaultFabVariant = fabVariants.primary;
